import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './nextAvailable.scss';
import Popup from '../../../components/Popup';
import { CheckBox } from '../../../components/Form';

const ConfirmationPopup = (props) => {
    const {
        title,
        description,
        needsCheckbox,
        checkboxText,
        cancelText,
        confirmText,
        onCancel,
        onConfirm,
        'data-testid': dataTestId,
    } = props;

    const [checkboxValue, setCheckboxValue] = useState(true);

    const onCloseStartConfirmPopup = () => {
        onCancel();
    };

    const onChangeCheckbox = (value) => {
        setCheckboxValue(value);
    };

    const onConfirmClicked = () => {
        if (needsCheckbox) {
            onConfirm(checkboxValue);
        } else {
            onConfirm();
        }
    };

    const onCancelClicked = () => {
        onCancel();
    };

    return (
        <Popup
            className="popup-sm"
            popUpClassName={styles.confirmPopup}
            onCloseClick={onCloseStartConfirmPopup}
            closeOnClickOutside={false}
            data-testid={dataTestId}
            config={{
                fullScreen: false,
                noPadding: true,
                scrollable: false,
                showCloseIcon: false,
            }}
        >
            {title && (
                <h6 className={styles.title} data-testid={dataTestId && `${dataTestId}.title`}>
                    {title}
                </h6>
            )}
            {description && (
                <p className={styles.description} data-testid={dataTestId && `${dataTestId}.description`}>
                    {description}
                </p>
            )}
            {needsCheckbox && (
                <CheckBox
                    controlled={true}
                    id={`checkbox`}
                    customLabel={checkboxText}
                    checked={checkboxValue}
                    onChange={onChangeCheckbox}
                    data-testid={dataTestId && `${dataTestId}.notify-checkbox`}
                />
            )}
            <div className="d-flex mt16">
                {cancelText && (
                    <button
                        className="btn btn-default flex-1 mr8"
                        type="button"
                        onClick={onCancelClicked}
                        data-testid={dataTestId && `${dataTestId}.cancel-btn`}
                    >
                        {cancelText}
                    </button>
                )}
                {confirmText && (
                    <button
                        className="btn btn-primary flex-1"
                        type="button"
                        onClick={onConfirmClicked}
                        data-testid={dataTestId && `${dataTestId}.confirm-btn`}
                    >
                        {confirmText}
                    </button>
                )}
            </div>
        </Popup>
    );
};

ConfirmationPopup.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    needsCheckbox: PropTypes.bool,
    checkboxText: PropTypes.string,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    'data-testid': PropTypes.string,
};

ConfirmationPopup.defaultProps = {
    title: '',
    description: '',
    needsCheckbox: false,
    checkboxText: '',
    cancelText: '',
    confirmText: '',
    onCancel: () => {},
    onConfirm: () => {},
    'data-testid': undefined,
};

export default ConfirmationPopup;
